export const validation = {
  headingMaxChar: 24,
  paragraphMaxChar: 120,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}
